(ns app.components.menus.views
  (:require [app.components.buttons.views :refer [icon-button]]
            [app.components.buttons.views :as buttons]
            [app.components.icons.views :refer [avatar chevron-down-icon
                                                copy-link-icon delete-icon
                                                duplicate-icon edit-icon elipsis-icon logout-icon move-copy-to-icon profile-icon
                                                settings-icon users-icon view-icon]]
            [app.components.menus.styles :refer [delete-button empty-menu-list-item
                                                 folder-item-menu-box menu-list-item
                                                 popover-menu workspaces-menu-box]]
            [app.dashboard.events :as wevents]
            [app.endpoints :refer [strive-react-endpoint strive-live-react-endpoint]]
            [app.events :as events]
            [app.subs :as subs]
            [re-com.core :as re-com :refer [popover-anchor-wrapper
                                            popover-content-wrapper v-box]]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [clojure.string :as s]
            [reagent-mui.material.list-item-icon :refer [list-item-icon]]
            [reagent-mui.material.menu :refer [menu]]
            [reagent-mui.material.menu-item :refer [menu-item]]
            [reagent.core :as r]))

(defn account-settings [workspace-id] 
  (let [showing? (r/atom false) 
        username @(re-posh/subscribe [::subs/user-name])
        user-profile-pic (:user/profile-pic username)] 
    [popover-anchor-wrapper
     :showing? showing?
     :position :below-center
     :anchor [icon-button {:icon chevron-down-icon  :onClick #(swap! showing? not)}]
     :popover [popover-content-wrapper
               :arrow-length 0
               :on-cancel #(swap! showing? not)
               :class (popover-menu)
               :no-clip? true
               :body [v-box
                      :gap "4px"
                      :style {:padding "8px" :background "white" :width "fit-content" :border "1px solid #E0DFE4" :border-radius "8px" :filter "drop-shadow(0px 3px 2px rgba(0, 0, 0, 0.06)) drop-shadow(0px 10px 4px rgba(0, 0, 0, 0.1)) "}
                      :children [[buttons/left-icon-button {:icon (if (or (nil? user-profile-pic) (= "" user-profile-pic)) profile-icon avatar)
                                                            :icon-src user-profile-pic
                                                            :name "Account Settings"
                                                            :selected false
                                                            :onClick #(do
                                                                        (re-frame/dispatch [::events/navigate [:account-settings :id workspace-id]])
                                                                        (swap! showing? not))}]
                                 [buttons/left-icon-button {:icon settings-icon
                                                            :name "Workspace Settings"
                                                            :selected false
                                                            :onClick #(do
                                                                        (re-frame/dispatch [::events/navigate [:workspace-settings :id workspace-id]])
                                                                        (swap! showing? not))}]
                                 [buttons/left-icon-button {:icon users-icon
                                                            :name "Workspace members"
                                                            :selected false
                                                            :onClick #(do 
                                                                        (re-frame/dispatch [::events/navigate [:members-view :id workspace-id]])
                                                                        (swap! showing? not))}]
                                 [buttons/left-icon-button {:icon logout-icon
                                                            :name "Log out"
                                                            :selected false
                                                            :style {:color "#FF4975"}
                                                            :onClick #(do
                                                                        (.clear (.-localStorage js/window))
                                                                        (re-frame/dispatch [::events/navigate [:login]])
                                                                        (swap! showing? not))}]]]]]))

(defn folder-item-ellipsis-menu [folder-id delete-action copyLink label-clicked-out? clicked-folder-details clicked-workspace-id clicked-workspace-name count hover?]
  (let [showing? (r/atom false)]
    (fn []
      [:div
       [buttons/icon-button {:id (str "delete-dropdown-button-" folder-id) :icon elipsis-icon
                             :aria-controls "folder-item-menu"
                             :aria-haspopup true
                             :aria-expanded true
                             :onClick #(do
                                         (.stopPropagation %)
                                         (swap! showing? not))}]
       [menu {:id "folder-item-menu"
              :aria-labelledby (str "delete-dropdown-button-" folder-id)
              :open @showing?
              :onClose  #(do (.stopPropagation %)
                             (swap! showing? not)
                             (reset! hover? false))
              :MenuListProps {:aria-labelledby (str "delete-dropdown-button-" folder-id)}
              :anchorEl (.getElementById js/document (str "delete-dropdown-button-" folder-id))
              :class (folder-item-menu-box)}
        [menu-item {:class (menu-list-item)
                    :onClick #(do
                                (.stopPropagation %)
                                (reset! label-clicked-out? true)
                                (swap! showing? not))}
         [list-item-icon [edit-icon]] "Rename"]
        [menu-item  {:class (menu-list-item) :onClick copyLink}
         [list-item-icon [copy-link-icon]] "Copy Link"]
        [menu-item {:class (delete-button) :onClick #(do (.stopPropagation %)
                                                                (reset! clicked-folder-details {:folder-id clicked-workspace-id :folder-name clicked-workspace-name :count count})
                                                                (delete-action))}
         [list-item-icon [delete-icon]] "Delete"]]])))

(defn folder-item-menu-component [delete-action copyLink label-clicked-out? context-menu hover?]
  [menu {:id "folder-item-menu"
         :aria-labelledby "folder-item-label"
         :open (and (some? @context-menu) (= :folder-item (:type @context-menu)))
         :onClose  #(do (.stopPropagation %)
                        (reset! context-menu nil)
                        (reset! hover? false))
         :MenuListProps {:aria-labelledby "folder-item-label"}
         :anchorEl (.getElementById js/document "folder-item-label")
         :class (folder-item-menu-box)
         :anchorReference "anchorPosition"
         :anchorPosition {:top (:mouse-y @context-menu) :left (:mouse-x @context-menu)}}

   [menu-item {:class (menu-list-item) :onClick #(do
                                                   (.stopPropagation %)
                                                   (reset! label-clicked-out? true)
                                                   (reset! context-menu nil))} "Rename"]
   [menu-item  {:class (menu-list-item) :onClick copyLink}  "Copy Link"]
   [menu-item {:class (delete-button) :onClick #(do (.stopPropagation %)
                                                           (delete-action)
                                                           (reset! context-menu nil))}  "Delete"]])

(defn project-card-ellipsis-menu [menu-id link label-clicked-out? show-workspaces-menu? copyLink type workspace-id selected-folder-id product-form-id showing-settings? product-form-name product-form-secondary-id product-description action product-form-array assets-selected delete-notification]
  (fn []
    [:div
     {:style {:height "24px"}}
     [buttons/icon-button {:id (str "project-card-ellipsis-button-" product-form-id) :icon elipsis-icon
                           :aria-controls (str "project-card-menu-" product-form-id)
                           :aria-haspopup true
                           :aria-expanded true
                           :onClick #(do
                                       (.stopPropagation %)
                                       (swap! showing-settings? not)
                                       (reset! menu-id "ellipsis-menu-move-to-button"))}]
     [menu {:id (str "project-card-menu-" product-form-id)
            :aria-labelledby (str "project-card-ellipsis-button-" product-form-id)
            :open @showing-settings?
            :onClose  #(reset! showing-settings? false)
            :MenuListProps {:aria-labelledby (str "project-card-ellipsis-button-" product-form-id)}
            :anchorEl (.getElementById js/document (str "project-card-ellipsis-button-" product-form-id))
            :class (folder-item-menu-box)}
      [menu-item  {:class (menu-list-item) :onClick #((js/window.location.assign link))} [list-item-icon [view-icon]] "View"]
      [menu-item {:class (menu-list-item) :onClick (fn [_]
                                                     (reset! label-clicked-out? true)
                                                     (swap! showing-settings? not))} [list-item-icon [edit-icon]] "Rename"]
      [menu-item  {:class (menu-list-item) :onClick (if (= type :product)
                                                      #(do (re-posh/dispatch [::wevents/duplicate-product  {:workspace-id workspace-id :folder-id selected-folder-id :product-id product-form-id :name product-form-name :product-description product-description :product-template-id product-form-secondary-id}])
                                                           (swap! showing-settings? not))
                                                      #(do (re-posh/dispatch [::wevents/duplicate-form  {:workspace-id workspace-id :folder-id selected-folder-id :form-id product-form-id :name product-form-name :form-id-str product-form-secondary-id}])
                                                           (swap! showing-settings? not)))} [list-item-icon [duplicate-icon]] "Duplicate"]
      [menu-item  {:id @menu-id :class (menu-list-item) :onClick #(do (reset! show-workspaces-menu? true)
                                                                      (reset! action :move)
                                                                      (reset! assets-selected (conj @assets-selected {:type type :id product-form-id})))} [list-item-icon [move-copy-to-icon]] "Move to"]
      [menu-item  {:class (menu-list-item)  :onClick #(do (reset! show-workspaces-menu? true)
                                                          (reset! action :copy)
                                                          (reset! assets-selected (conj @assets-selected {:type type :id product-form-id :name product-form-name :secondary-id product-form-secondary-id :product-description product-description})))} [list-item-icon [move-copy-to-icon]] "Copy to"]
      [menu-item  {:class (menu-list-item) :onClick #(do (copyLink)
                                                         (swap! showing-settings? not))} [list-item-icon [copy-link-icon]] "Copy Link"]
      [menu-item {:class (delete-button) :onClick (if (= type :product)
                                                           #(do (re-posh/dispatch [::wevents/delete-product-local  {:products product-form-array :product-id product-form-id}])
                                                                (re-posh/dispatch [::wevents/delete-product  {:workspace-id workspace-id :folder-id selected-folder-id :product-id product-form-id}])
                                                                (re-posh/dispatch [::wevents/add-last-action  {:asset [{:type type :id (str product-form-id)}]
                                                                                                               :name product-form-name
                                                                                                               :type (if (= type :product)
                                                                                                                       "Product"
                                                                                                                       "Form")}]) 
                                                                (swap! delete-notification not)
                                                                (swap! showing-settings? not))
                                                           #(do (re-posh/dispatch [::wevents/delete-form-local  {:forms product-form-array :form-id product-form-id}])
                                                                (re-posh/dispatch [::wevents/delete-form  {:workspace-id workspace-id :folder-id selected-folder-id :form-id product-form-id}])
                                                                (re-posh/dispatch [::wevents/add-last-action  {:asset [{:type type :id (str product-form-id)}]
                                                                                                               :name product-form-name
                                                                                                               :type (if (= type :product)
                                                                                                                       "Product"
                                                                                                                       "Form")}]) 
                                                                (swap! delete-notification not)
                                                                (swap! showing-settings? not)))} [list-item-icon [delete-icon]] "Delete"]]]))

(defn project-card-menu-component [menu-id link label-clicked-out? show-workspaces-menu? context-menu copyLink type workspace-id selected-folder-id product-form-id product-form-name product-form-secondary-id product-description action showing-settings? product-form-array assets-selected delete-notification]
  [menu {:id (str "project-card-menu-" product-form-id)
         :aria-labelledby "project-card-label"
         :open (and (some? @context-menu) (= :project-card (:type @context-menu)) (= product-form-id (:id @context-menu)))
         :onClose  #(do (reset! context-menu nil)
                        (reset! showing-settings? false))
         :MenuListProps {:aria-labelledby "project-card-label"}
         :anchorEl (.getElementById js/document "project-card-label")
         :class (folder-item-menu-box)
         :anchorReference "anchorPosition"
         :anchorPosition {:top (:mouse-y @context-menu) :left (:mouse-x @context-menu)}}
   [menu-item  {:class (menu-list-item) :onClick #((js/window.location.assign link))} "View"]
   [menu-item {:class (menu-list-item) :onClick (fn [_]
                                                  (reset! label-clicked-out? true)
                                                  (reset! context-menu nil))} "Rename"]
   [menu-item  {:class (menu-list-item) :onClick (if (= type :product)
                                                   #(do (re-posh/dispatch [::wevents/duplicate-product  {:workspace-id workspace-id :folder-id selected-folder-id :product-id product-form-id :name product-form-name :product-description product-description :product-template-id product-form-secondary-id}])
                                                        (reset! context-menu nil))
                                                   #(do (re-posh/dispatch [::wevents/duplicate-form  {:workspace-id workspace-id :folder-id selected-folder-id :form-id product-form-id :name product-form-name :form-id-str product-form-secondary-id}])
                                                        (reset! context-menu nil)))}  "Duplicate"]
   [menu-item  {:id @menu-id :class (menu-list-item) :onClick #(do (reset! show-workspaces-menu? true)
                                                                   (reset! action :move)
                                                                   (reset! assets-selected (conj @assets-selected {:type type :id product-form-id})))}  "Move to"]
   [menu-item  {:class (menu-list-item)  :onClick #(do (reset! show-workspaces-menu? true)
                                                       (reset! action :copy)
                                                       (reset! assets-selected (conj @assets-selected {:type type :id product-form-id :name product-form-name :secondary-id product-form-secondary-id :product-description product-description})))}  "Copy to"]
   [menu-item  {:class (menu-list-item) :onClick #(do (copyLink)
                                                      (reset! context-menu nil))}  "Copy Link"]
   [menu-item {:class (delete-button) :onClick (if (= type :product)
                                                        #(do (re-posh/dispatch [::wevents/delete-product-local  {:products product-form-array :product-id product-form-id}])
                                                             (re-posh/dispatch [::wevents/delete-product  {:workspace-id workspace-id :folder-id selected-folder-id :product-id product-form-id}])
                                                             (re-posh/dispatch [::wevents/add-last-action  {:asset [{:type type :id (str product-form-id)}]
                                                                                                            :name product-form-name
                                                                                                            :type (if (= type :product)
                                                                                                                    "Product"
                                                                                                                    "Form")}]) 
                                                             (swap! delete-notification not)
                                                             (reset! context-menu nil))
                                                        #(do
                                                           (re-posh/dispatch [::wevents/delete-form-local  {:forms product-form-array :form-id product-form-id}])
                                                           (re-posh/dispatch [::wevents/delete-form  {:workspace-id workspace-id :folder-id selected-folder-id :form-id product-form-id}])
                                                           (re-posh/dispatch [::wevents/add-last-action  {:asset [{:type type :id (str product-form-id)}]
                                                                                                          :name product-form-name
                                                                                                          :type (if (= type :product)
                                                                                                                  "Product"
                                                                                                                  "Form")}]) 
                                                           (swap! delete-notification not)
                                                           (reset! context-menu nil)))}  "Delete"]])

(defn workpaces-menu [{:keys [menu-id show-workspaces-menu? workspace-id selected-folder-id workspace-data type product-form-id context-menu showing-settings? product-form-name product-form-secondary-id product-description action assets-selected move-notification copy-notification array-of-ticked]}]
  (let [sorted-workspace-data (sort-by :name (:selected-workspace/folders workspace-data))] 
    [menu {:id "workspaces-menu"
           :aria-labelledby @menu-id
           :open @show-workspaces-menu?
           :onClose  #(do (swap! show-workspaces-menu? not)
                          (reset! showing-settings? false)
                          (reset! context-menu nil))
           :MenuListProps {:aria-labelledby @menu-id}
           :anchorEl (.getElementById js/document @menu-id)
           :transformOrigin {:vertical "center" :horizontal "left"}
           :class (workspaces-menu-box @menu-id)}

     (map (fn [{:keys [id workspace_id name]}]
            ^{:key (str id name)} 
            [menu-item  {:class (if (= name "") (empty-menu-list-item) (menu-list-item)) :onClick (if (= @action :create) #(do (swap! show-workspaces-menu? not)
                                                                                       (if (= type "Product") 
                                                                                         (re-posh/dispatch [::wevents/create-product {:workspace-id workspace-id :folder-id workspace_id}])
                                                                                         (re-posh/dispatch [::wevents/create-form {:workspace-id workspace-id :folder-id workspace_id}])))
                                                              (if (= @action :move) #(do (swap! show-workspaces-menu? not)
                                                                                     (reset! context-menu nil)
                                                                                     (swap! showing-settings? not)
                                                                                     (wevents/move-multiple-assets workspace-id selected-folder-id assets-selected move-notification workspace_id)
                                                                                     (reset! assets-selected nil)
                                                                                     (swap! move-notification not)
                                                                                     (reset! array-of-ticked (mapv (fn [x] (update x :ticked (fn [e]
                                                                                                                                               false))) @array-of-ticked)))

                                                              #(do (swap! show-workspaces-menu? not)
                                                                   (reset! context-menu nil)
                                                                   (swap! showing-settings? not)
                                                                   (wevents/copy-multiple-assets (:selected-workspace/id workspace-data) selected-folder-id assets-selected move-notification workspace_id)
                                                                   (reset! assets-selected nil)
                                                                   (swap! copy-notification not)
                                                                   (reset! array-of-ticked (mapv (fn [x] (update x :ticked (fn [e]
                                                                                                                             false))) @array-of-ticked)))))} (if (= name "") "Untitled" name)])
          sorted-workspace-data)]))

(defn create-menu [{:keys [menu-id show-create-menu? create-new-product create-new-form]}]
  [menu {:id "create-menu"
         :aria-labelledby @menu-id
         :open @show-create-menu?
         :onClose  #(do (reset! show-create-menu? false))
         :MenuListProps {:aria-labelledby @menu-id}
         :anchorEl (.getElementById js/document @menu-id)
         :transformOrigin {:vertical "top" :horizontal "left"}
         }
   [menu-item  {:class (menu-list-item) :onClick #(do (create-new-product)
                                                      (swap! show-create-menu? not))} "Product"]
   [menu-item  {:class (menu-list-item) :onClick #(do (create-new-form)
                                                      (swap! show-create-menu? not))} "Form"]])

(defn members-role-menu [{:keys [role-selected]}]
  (let [showing? (r/atom false)]
    (fn []
      [:div
       [buttons/menu-button {:action :cta
                             :type :secondary
                             :title (str "Role: " @role-selected)
                             :size :small
                             :attr {:id "members-role-menu-button"
                                    :aria-controls "members-role-menu"
                                    :aria-haspopup true
                                    :aria-expanded true}
                             :icon chevron-down-icon
                             :onClick #(do
                                         (.stopPropagation %)
                                         (swap! showing? not))}]
       [menu {:id "members-role-menu"
              :aria-labelledby "members-role-menu-button"
              :open @showing?
              :onClose  #(do (.stopPropagation %)
                             (swap! showing? not))
              :MenuListProps {:aria-labelledby "members-role-menu-button"}
              :anchorEl (.getElementById js/document "members-role-menu-button")
              :class (folder-item-menu-box)}

        [menu-item  {:class (menu-list-item) :onClick #(do (reset! role-selected "All")
                                                           (swap! showing? not))
                     :selected (= "All" @role-selected)}
         "All"]
        [menu-item  {:class (menu-list-item) :onClick #(do (reset! role-selected "Owner")
                                                           (swap! showing? not))
                     :selected (= "Owner" @role-selected)}
         "Owner"]
        [menu-item  {:class (menu-list-item) :onClick #(do (reset! role-selected "Admin")
                                                           (swap! showing? not))
                     :selected (= "Admin" @role-selected)}
         "Admin"]
        [menu-item  {:class (menu-list-item) :onClick #(do (reset! role-selected "Collaborator")
                                                           (swap! showing? not))
                     :selected (= "Collaborator" @role-selected)}
         "Collaborator"]]])))

(defn members-role-switch-menu [{:keys [role-selected email]}]
  (let [showing? (r/atom false)]
    (fn []
      [:div
       [buttons/menu-button {:action :cta
                             :type :secondary
                             :title @role-selected
                             :size :small
                             :attr {:id (str "member-role-menu-button" email)
                                    :aria-controls "member-role-menu"
                                    :aria-haspopup true
                                    :aria-expanded true}
                             :icon chevron-down-icon
                             :onClick #(do
                                         (.stopPropagation %)
                                         (swap! showing? not))}]
       [menu {:id "member-role-menu"
              :aria-labelledby (str "member-role-menu-button" email)
              :open @showing?
              :onClose  #(do (.stopPropagation %)
                             (swap! showing? not))
              :MenuListProps {:aria-labelledby (str "member-role-menu-button" email)}
              :anchorEl (.getElementById js/document (str "member-role-menu-button" email))
              :class (folder-item-menu-box)}

        [menu-item  {:class (menu-list-item) :onClick #(do (reset! role-selected "Admin")
                                                           (swap! showing? not))
                     :selected (= "Admin" @role-selected)}
         "Admin"]
        [menu-item  {:class (menu-list-item) :onClick #(do (reset! role-selected "Collaborator")
                                                           (swap! showing? not))
                     :selected (= "Collaborator" @role-selected)}
         "Collaborator"]
        [menu-item  {:class (delete-button) :onClick #(do (reset! role-selected "Collaborator")
                                                                 (swap! showing? not))}
         "Remove"]]])))

;;generic-components
(defn table-item-menu-component [context-menu show-context-menu? actions]
  [menu {:id (str "table-item-menu-" "id")
         :aria-labelledby "card-label"
         :open (and show-context-menu? (some? @context-menu))
         :onClose  #(do (reset! context-menu nil)
                        )
         :MenuListProps {:aria-labelledby "card-label"}
         :anchorEl (.getElementById js/document "card-label")
         :class (folder-item-menu-box)
         :anchorReference "anchorPosition"
         :anchorPosition {:top (:mouse-y @context-menu) :left (:mouse-x @context-menu)}} 
   (map (fn [value]
          ^{:key (str "menu-actions-" (:title value))} 
          [menu-item  {:class
                       (if (s/includes? (:title value) "Delete")
                         (delete-button)
                         (menu-list-item))
                       :onClick (:action value)} (:title value)]) actions)])